module.exports = __webpack_public_path__ + "static/media/a-man-called-otto.fe5da889.webp";